import html from "../privacy-employees.html?raw";
import scripts from "../scripts/terms-of-use.json";

import type { MirrorContent } from "../pages";

export const content: MirrorContent = { html, scripts };
export default content;
